import { render, staticRenderFns } from "./MoneyDocumentIcon.vue?vue&type=template&id=0616c173&scoped=true"
import script from "./MoneyDocumentIcon.vue?vue&type=script&lang=js"
export * from "./MoneyDocumentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0616c173",
  null
  
)

export default component.exports